<template>
  <div id="app">
    <nav class="navbar navbar-expand-lg navbar-light">
      <!-- <span> -->
        <!-- <img src="/img/logo.png" alt="CodeHit Logo" width="32" class="img-fluid"> -->
        <router-link to="/">
          <span class="navbar-brand mb-0 h1 pt-0 pb-0 pr-1 mr-0 pl-1">
            CodeHit
          </span>
        </router-link>
      <!-- </span> -->

      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navMenu" v-on:click="showMenu = !showMenu" aria-controls="navMenu" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div :class="'collapse navbar-collapse ' + (showMenu ? 'show' : '')" id="navMenu">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item">
            <router-link class="nav-link" to="/merp">@mERP</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/money-monit">@moneyMonit</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/prog-monit">@progMonit</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/act-monit">@actMonit</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/mats-monit">@matsMonit</router-link>
          </li>
          <!-- <li class="nav-item">
            <router-link class="nav-link" to="/">@bugX</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/">@familyTree</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/">@calcList</router-link>
          </li>
           -->
          <!-- <li class="nav-item active">
            <router-link class="nav-link" to="/contact">Contact Us</router-link>
          </li> -->
        </ul>
      </div>
    </nav>
    <router-view/>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showMenu: false
    }
  }
}
</script>

<style lang="scss">
  .navbar.navbar-light{
    background-color: #e9ecef;
    .navbar-brand {
      border: 1px solid #fff;
      border-radius: 5px;
    }
  }

  .nav-link.router-link-exact-active {
    color: rgb(0,0,0)!important;
  }

  #navMenu.show {
    .navbar-nav {
      position: absolute;
      background: #e9ecef;
      width: 100%;
      margin-left: -15px;
      padding-left: 15px;
      z-index: 10;
    }
  }

  footer{
    background-color: #f7f7f7;
    font-size: .875rem;
    ul {
      padding-left: 0;
      li {
        display: inline-block;
        a {
          font-weight: 600;
          color: #495057;
        }
      }
      li+li {
        margin-left: 1rem;
      }
    }
  }
</style>
